import { useEffect, useState } from 'react'
import { Button } from 'reactstrap'
import { useSnackbar } from 'notistack'
import { apiEndpoint } from 'configs'
import axios from 'axios'
import { P } from 'components'

export default function TermsAndConditionsConsent({
  onConfirmed,
  fullscreen = false,
  titleTarget,
  isOpen,
  handleClose,
}) {
  const { enqueueSnackbar } = useSnackbar()

  const [tncText, setTncText] = useState('')
  const [hasScrolledToEnd, setHasScrolledToEnd] = useState(false)
  const [tncVersion, setTncVersion] = useState('')

  useEffect(() => {
    const fetchTnc = async () => {
      try {
        const res = await axios.get(`${apiEndpoint}/api/v1/public/tnc`, {
          headers: {
            'User-Agent': 'PasarMIKRO',
            Authorization: `d2hhdHNhcHBXZWJob29rOlBNWFlXQUlTYW5kQm94`,
          },
        })

        setTncText(res.data)
        setTncVersion(res.headers['tnc-version'])
      } catch (err) {
        enqueueSnackbar('Gagal memuat TnC', { variant: 'error' })
      }
    }

    fetchTnc()
  }, [])

  useEffect(() => {
    if (isOpen) {
      if (titleTarget) {
        setTimeout(() => {
          const target = document.getElementById(titleTarget)
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        }, 100)
      }
    }
  }, [isOpen])

  const handleConfirm = async () => {
    try {
      enqueueSnackbar('Persetujuan TnC berhasil', { variant: 'success' })
      onConfirmed?.(tncVersion)
      handleClose()
    } catch (err) {
      enqueueSnackbar('Gagal menyimpan persetujuan TnC', { variant: 'error' })
    }
  }

  return (
    <>
      {isOpen && (
        <div
          className="modal show d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          data-testid="tnc-consent-modal"
        >
          <div
            className={`modal-dialog ${fullscreen ? 'modal-fullscreen' : 'modal-dialog-scrollable'
              }`}
          >
            <div className="modal-content">
              <div className="modal-header">
                <P size="large">Syarat dan Ketentuan</P>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                  data-testid="tnc-consent-close"
                />
              </div>
              <div
                className="modal-body hide-scrollbar tnc-container-custom"
                style={{
                  width: '100%',
                  overflowX: 'hidden',
                  overflowY: 'auto',
                  paddingLeft: 20,
                  paddingRight: 20,
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                  maxHeight: fullscreen ? 'calc(100vh - 150px)' : undefined,
                }}
                onScroll={(e) => {
                  const { scrollTop, scrollHeight, clientHeight } = e.target
                  if (scrollTop + clientHeight >= scrollHeight - 10) {
                    setHasScrolledToEnd(true)
                  }
                }}
              >
                <style>{`
                  .tnc-container-custom .legal-document {
                    margin-left: 0 !important;
                    margin-right: 0 !important;
                    max-width: 100% !important;
                    width: 100% !important;
                    min-height: auto !important;
                    box-sizing: border-box !important;
                  }
                  .tnc-container-custom .legal-numbered-label {
                    white-space: nowrap !important;
                    width: auto !important;
                    display: inline-block !important;
                  }
                  .tnc-container-custom .legal-numbered-row {
                    word-break: normal !important;
                    overflow-wrap: break-word !important;
                  }
                `}</style>
                <div dangerouslySetInnerHTML={{ __html: tncText }} />
              </div>
              {onConfirmed ? (
                <div className="modal-footer">
                  {!hasScrolledToEnd && (
                    <small className="text-muted me-auto">
                      Silakan scroll hingga akhir untuk mengaktifkan tombol
                      persetujuan.
                    </small>
                  )}

                  <Button
                    color="primary"
                    disabled={!hasScrolledToEnd}
                    onClick={handleConfirm}
                    className="w-100"
                    data-testid="tnc-consent-confirm"
                  >
                    Saya Mengerti dan Menyetujui
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </>
  )
}